GatiServerGame = function () {
  var base = new GatiServer();
  GatiServer.call(this, base);
  this.inFreeSpins = false;
  this.slotConfig = undefined;
  this.fsWinnings = 0;
  this.fsCount = 0;
  this.cashLinkCostMultiplier;
  this.freeSpinsCostMultiplier;
  this.force = undefined;
  this.cashLinkActive = false;
  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;
  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;
  this.isGameModeBonusBuy = this.isGameModeBonusBuyDerived;
  this.restorePreviousWagersBase = this.restorePreviousWagers;
  this.restorePreviousWagers = this.restorePreviousWagersDerived;
  this._inBuyABonus = false;
  this._inEncore = false;
  //this.loadLanguageFiles = undefined; //TODO: delete me when translations are ready
  this.prepaidInitialBalance = 0;
  this.prepaidResultBalance = 0;
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    undefined,
    "LEFT_TOP"
  );
};

GatiServer.prototype.clientReadyToStart = function (cbWhenPlatformReady) {
  var self = this;
  const informGameReady = async (slot) => {
    var readyResponse = await slot
      .getGameEventsEmitter()
      .gameReady({ defaultBetValue: this._stake / 100 });
    console.log(
      "Gati Platform: Restore Mode set to " + readyResponse.restoreMode
    );
    gameData.prepaidSpinsLeft =
      readyResponse.nextPrepaid === undefined ? 0 : readyResponse.nextPrepaid;
    // no longer modal
    messageBus.post("game:modal", {});
    self._finishedLoading = true;
    self._isRecoveryGame = readyResponse.restoreMode === "RESTORE";
    if (self._inRewatchMode || self._inReplayMode || self._isRecoveryGame) {
      gdk.startMinGameTimer(); // we bypass start during recovery so the gdk wont do this for us
      self._isPrePaidGame = true; // Tells setBPL not to show max stake popup, this is a recover game they have already seen this popup
      let stakeInfo = self.restorePreviousWagers();
      self._isPrePaidGame = slot.getWagerHelper().getPrepaidInfo().isPrepaid; //prepaids has a very specifice purpose and this isnt it, so put it back!
      self.initNewGame(
        { stake: stakeInfo.stake, bpl: stakeInfo.baseStake / self._numLines },
        self._isRecoveryGame
      );

      // now initGame no longer sends balance out because PokerStars doesnt want to the debit until
      // a result has been received so there are no errors, we must do it explicitly in side rewatch/recover/replay
      self.addBalanceEventToQueue();
      self.triggerNextMessage();

      self._latestEngineReponse = { wager: this._previousWagers.data[0] };
      self._wagerId = self._latestEngineReponse.wager.wagerid;
      await this._slotGame.getGameEventsEmitter().gameRoundStarted();
      await this._slotGame.getGameEventsEmitter().spinStarted();
      self.addRecoveryToQueue();
      self.triggerNextMessage();
      cbWhenPlatformReady();
      messageBus.postImmediate("common:GameCommitted");
    } else if (readyResponse.restoreMode === "SKIP") {
      self.restorePreviousWagers();
      self._latestEngineReponse = { wager: this._previousWagers.data[0] };
      if (self._latestEngineReponse.wager.bets.length) {
        let betData = self._latestEngineReponse.wager.bets[0].betdata;
        let stake = Number(betData.coin * 1000);
        gameData.recoveryStake = stake;

        if (betData.cmd === "LUCKYBET_BUY") {
          gameData.recoveryStake *= gameData.luckyBetUplift;
          gameData.goldenBetBtn.setRecovery();
        }
      }

      await self.handleSkipWin(self._latestEngineReponse);
      let win = await self.doCollectWinnings();
      gameData.winningsMeter.set(win);
      await self._slotGame.getGameEventsEmitter().gameRoundEnded();
      self._oldBalance = self._balance;
      self._preCommitBalance = self._balance;
      self.addBalanceEventToQueue();
      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);
      self.triggerNextMessage();
      cbWhenPlatformReady();
    } else {
      // Show help page if this is BR license and we are not restoring a game
      let license = gameData.license;
      if (license === "" || license === undefined) {
        license = "default";
      } else {
        license = gameData.license.toUpperCase();
      }

      if (license === "BR") {
        gameData.helpPageScroll.open();
      }
      self.checkForAndHandlePrepaids(readyResponse.nextPrepaid);
      cbWhenPlatformReady();
    }
  };

  // stop game interaction just in case the recovery popup will show (we dont know until we have a response from gameReady)
  messageBus.post("game:modal", {
    reason: "Waiting on Platform",
  });

  informGameReady(this._slotGame);
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  if (
    this._inReplayMode === true &&
    this._slotGame.getWagerHelper().getPrepaidInfo().isPrepaid === true
  ) {
    this.prepaidInitialBalance =
      parseFloat(loadData.wagers.data[0].bets[0].betdata.initialBalance) * 100;
    this.prepaidResultBalance =
      parseFloat(loadData.wagers.data[0].bets[0].eventdata.resultBalance) * 100;
  }
  this.addGameConfigToQueueBase(loadData);

  let message = this._messageQueue[0];

  this.cheatPanelActive = loadData.customParameters.cheatPanel === "yes";

  gameData.license = loadData.customParameters.license;

  if (gameData.license === "" || gameData.license === undefined) {
    gameData.license = "default";
  }

  message.slotConfig.coins = 10; // purely paytable

  //GAME DATA

  message.potData =
    loadData.settings.slotConfig.Config["spinner:GameConfigEvent"].pots;

  this.cashLinkCostMultiplier = message.buyBonusCostFireball =
    loadData.settings.modes.CASHLINK_BUY.coinsPerBet;

  this.freeSpinsCostMultiplier = message.buyBonusCostFreeSpins =
    loadData.settings.modes.FREESPINS_BUY.coinsPerBet;

  gameData.recoveryStake = undefined;

  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Number(betData.coin * 1000);

    gameData.recoveryStake = stake;

    if (betData.cmd === "LUCKYBET_BUY") {
      gameData.recoveryStake *= gameData.luckyBetUplift;
      message.slotConfig.recoverGB = true;
    }
  }

  gdk.addConfigValue(
    "AllowBuyBonus",
    message.slotConfig.gameModes["BONUS_BUY"] ? true : false
  );

  gdk.addConfigValue("lang", loadData.settings.language);

  message.maxExposure = loadData.settings.slotConfig.MaxExposure;

  this.processWilds(
    loadData.settings.slotConfig.Config["spinner:GameConfigEvent"].slotConfig
      .startingSymbols
  );
};

GatiServer.prototype.isGameModeBonusBuyDerived = function (mode) {
  return mode === "CASHLINK_BUY" || mode === "FREESPINS_BUY";
};

GatiServerGame.prototype.processWilds = function (reelList, above, below) {
  //NOTE: Count how many in stack
  let wildStackAmount;

  //We do not want stack wilds on the symbols below view
  if (above) {
    for (let reel = 0; reel < above.length; reel++) {
      let wildStackAmount = 0;
      let changeWild = false;
      const symbolsAbove = above[reel].symbols;
      const symbolsInReel = reelList[reel].symbols;

      for (let row = 0; row < symbolsAbove.length; row++) {
        const symbol = symbolsAbove[row];

        // NOTE: If stacked wild: should just be symbol 10
        if (symbol.value === 10) {
          reelWithWildStack = reel;
          wildStackAmount++;

          // Check if it's the bottom-most symbol of the stack
          const isBottomOfStack = row === symbolsAbove.length - 1;
          const firstReelSymbol = symbolsInReel[0]?.value;
          const secondReelSymbol = symbolsInReel[1]?.value;

          if (
            isBottomOfStack &&
            firstReelSymbol === 10 &&
            secondReelSymbol !== 10
          ) {
            changeWild = true;
          }
        }
      }

      if (changeWild) {
        // Change the first reel symbol from wild (10) to 9
        symbolsInReel[0].value = 9;
      }

      if (wildStackAmount > 0) {
        // Sometimes the stacked wilds are coming in as 9
        this.removeSuperWildOnReel(symbolsAbove);
      }
    }
  }

  //We do not want stack wilds on the symbols below view
  if (below) {
    for (let reel = 0; reel < below.length; reel++) {
      let wildStackAmount = 0;
      const symbolsBelow = below[reel].symbols;

      for (const symbol of symbolsBelow) {
        // NOTE: If stacked wild: should just be symbol 10
        if (symbol.value === 10) {
          reelWithWildStack = reel;
          wildStackAmount++;
        }
      }

      if (wildStackAmount > 0) {
        // Sometimes the stacked wilds are coming in as 9
        this.removeSuperWildOnReel(symbolsBelow);
      }
    }
  }

  for (let reel = 0; reel < reelList.length; reel++) {
    const symbols = reelList[reel].symbols;
    wildStackAmount = 0;

    for (const symbol of symbols) {
      if (symbol.value === 10) {
        wildStackAmount++;
      }
    }

    if (wildStackAmount > 0) {
      const replacementId =
        gameData.symbols[`Symbol_Wild_1x${wildStackAmount}`].ID;

      this.replaceSuperWildOnReel(symbols, replacementId);
    }
  }
};

GatiServerGame.prototype.processAboveBelowOversize = function (above, below) {
  for (let reel = 0; reel < above.length; reel++) {
    for (let row = 0; row < above[reel].symbols.length; row++) {
      if (above[reel].symbols[row].value > 5) {
        above[reel].symbols[row].value = Math.floor(
          Math.random() * (4 - 0 + 1) + 0
        ); //replace with low sym
      }
    }
  }

  for (let reel = 0; reel < below.length; reel++) {
    for (let row = 0; row < below[reel].symbols.length; row++) {
      if (below[reel].symbols[row].value > 5) {
        below[reel].symbols[row].value = Math.floor(
          Math.random() * (4 - 0 + 1) + 0
        ); //replace with low sym
      }
    }
  }
};

GatiServerGame.prototype.setBPL = function (bpl) {
  // this doesn't set the correct stake in recovery - but shouldn't affect anything...
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;

  if (gameData.encoreEnabled) {
    newStake *= gameData.luckyBetUplift;
  }

  this.updateCurrentStake(newStake);
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    let isStakeLower = newStake < this._stake;
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController("stakeController");
    if (
      sc.isMaxStake() &&
      !this._inReplayMode &&
      !this._inRewatchMode &&
      !this._isPrePaidGame &&
      !isStakeLower
    ) {
      this._slotGame.uiComponents().clickActionHandler();
    }
  }
};

GatiServerGame.prototype.restorePreviousWagersDerived = function () {
  let res = this.restorePreviousWagersBase();

  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === "LUCKYBET_BUY"
  ) {
    this.setDefaultBet(res.baseStake);
  }
  return res;
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === "LUCKYBET_BUY") {
      this._inEncore = true;
      this._meta = {
        name: "encore",
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === "CASHLINK_BUY") {
      this._inBuyABonus = true;
      this.cashLinkActive = true;
      this._meta = {
        name: "buyABonusCashLink",
        value: true,
        cashLinkActive: true,
      };
      break;
    } else if (bet.betdata.cmd === "FREESPINS_BUY") {
      this._inBuyABonus = true;
      this.cashLinkActive = false;
      this._meta = {
        name: "buyABonusFreeSpins",
        value: true,
        cashLinkActive: false,
      };
      break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this._inBuyABonus = stakeData.metaData.buyABonus;
  this._inEncore = stakeData.metaData.encore;

  this.cashLinkActive =
    stakeData.metaData.cashLinkActive !== undefined
      ? stakeData.metaData.cashLinkActive
      : false;

  if (this._forces === undefined || !this._forces) {
    this._forces = "";
    this.addCheatToRequest(stakeData, this._forces);
  }

  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  this._coinValue = 10;
  let stakeController = resourceManager.getController("stakeController");
  let baseStake = stakeController.getBaseStake("default") / 100;

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  if (this._forces === "" && this.cheatPanelActive) {
    request.cheat = JSON.stringify(null);
  }

  if (this._inEncore) {
    request.amount = baseStake * gameData.luckyBetUplift;
    request.coin = baseStake / this._coinValue;
    request.cmd = "LUCKYBET_BUY";
  } else if (this._inBuyABonus) {
    baseStake =
      stakeController.getBaseStake(
        this.cashLinkActive ? "CASHLINK_BUY" : "FREESPINS_BUY"
      ) / 100;

    request.amount =
      (baseStake / 10) *
      (this.cashLinkActive
        ? this.cashLinkCostMultiplier
        : this.freeSpinsCostMultiplier);
    request.coin = baseStake / this._coinValue;
    request.cmd = this.cashLinkActive ? "CASHLINK_BUY" : "FREESPINS_BUY";
  }
};

GatiServerGame.prototype.getSpinData = function (cb, data) {
  if (this.inCashLink) {
    this.getCashLinkSpinData(cb);
  } else if (this.inFreeSpins) {
    this.getSpinDataFS(cb);
  } else {
    let parts = data.Parts;

    this._forces = "";

    let hasFreespins = false;
    for (let i = 0; i < parts.length; ++i) {
      if (parts[i].type === "freeSpins") {
        hasFreespins = true;
      }
    }

    let totalWon = 0;
    for (let i = 0; i < parts.length; ++i) {
      let type = parts[i].type;
      if (type === "baseGame") {
        totalWon += this.getSpinDataNormal(parts[i]);
        // base game only, game complete
        if (!parts[i].cashLink.isAwarded && !hasFreespins) {
          this.addGameCompleteToQueue(totalWon);
        }
      } else if (type === "freeSpins") {
        this.inFreeSpins = true;
        this.fsCount = 0;
        this.freeSpins = parts[i].spins;

        const bonusSymbols = [];
        for (let reel = 0; reel < parts[0].stopWindow.reelList.length; ++reel) {
          for (
            let row = 0;
            row < parts[0].stopWindow.reelList[reel].symbols.length;
            ++row
          ) {
            const symbol =
              parts[0].stopWindow.reelList[reel].symbols[row].value;
            if (symbol === gameData.symbols["Symbol_Moon"].ID) {
              bonusSymbols.push({ reel, row });
            }
          }
        }

        this.addFSStartToQueue(
          parts[i].initialNumberOfSpins,
          parts[i].initialVolcanoBoosts,
          bonusSymbols
        );
      }
    }
    cb();
    this.triggerNextMessage();
  }
};

GatiServerGame.prototype.getSpinDataNormal = function (data) {
  const self = this;
  const spin = data;
  const spinEvent = this.setUpSpinEventData(data);
  const winningLinesEvent = data.payLines;

  if (!this.validateResponse(spinEvent)) return;
  if (!this.validateResponse(winningLinesEvent)) return;

  if (data.isWolfRun) {
    const wolfRunReels = this.getWolfRunReels(spinEvent.resultsPanel.reelList);
    this.addModifierEventToQueue(data, wolfRunReels);
  }

  this.processWilds(
    spinEvent.resultsPanel.reelList,
    spinEvent.resultsPanel.symbolsAbove,
    spinEvent.resultsPanel.symbolsBelow
  );

  this.processAboveBelowOversize(
    spinEvent.resultsPanel.symbolsAbove,
    spinEvent.resultsPanel.symbolsBelow
  );

  this.addSpinDataToQueue(spinEvent);

  const message = this._messageQueue[this._messageQueue.length - 1];
  message.cashLink = data.cashLink;

  const spinMessage = this._messageQueue[this._messageQueue.length - 1];

  spinMessage.powerPacks = [];

  data.powerPacks.forEach(function (pack) {
    const symbolId = gameData.symbols["Symbol_Power_Pack"].ID;
    spinMessage.powerPacks.push({
      reel: pack.reel,
      row: pack.row,
      symbolId,
      slotCell: pack.reel * gameData.numRows + pack.row,
    });
  });

  spinMessage.moons = [];
  data.moons.forEach(function (moon) {
    const symbolId = gameData.symbols["Symbol_Moon"].ID;
    spinMessage.moons.push({
      reel: moon.coord.reel,
      row: moon.coord.row,
      symbolId,
      slotCell: moon.coord.reel * gameData.numRows + moon.coord.row,
      numberOfSpins: moon.numberOfSpins,
    });
  });

  spinMessage.coins = [];
  spin.coins.forEach(function (coin) {
    const prizeData = self.getPrizeDataFromCoin(coin);
    spinMessage.coins.push({
      reel: coin.coord.reel,
      row: coin.coord.row,
      slotCell: coin.coord.reel * gameData.numRows + coin.coord.row,
      symbolId: gameData.symbols["Symbol_Coin"].ID,
      amount: prizeData.value,
      type: coin.type,
      potName: prizeData.potName,
      potValue: prizeData.value,
    });
  });

  spinMessage.isCashLink = data.cashLink.isAwarded;
  spinMessage.isCoinAwards = data.coinAwards.isAwarded;
  spinMessage.isWolfRun = data.isWolfRun;
  spinMessage.isPotBonus = data.potPick;

  if (
    !data.cashLink &&
    data.baseSpin.fireballs &&
    data.baseSpin.fireballs.length > 0
  ) {
    let fireballs = [...data.baseSpin.fireballs];

    this.addCoinsLandedToQueue(fireballs);
  }

  if (winningLinesEvent.totalLineWinnings > 0) {
    this.processSuperWildWins(winningLinesEvent, spin.stopWindow.reelList);
    this.addWinningsToQueue(winningLinesEvent);
    const message = this._messageQueue[this._messageQueue.length - 1];
    message.winIsCapped = spin.winCapped;
  }

  if (data.cashLink.isAwarded) {
    this.inCashLink = true;
    this.cashLinkCount = 0;
    this.cashLinkSpins = data.cashLink.spins;
    this.cashLinkTotalWin = data.cashLink.winAmount;
    this.addCashLinkStartToQueue(
      data.cashLink,
      data.coins,
      data.powerPacks,
      data.winCapped
    );
  }

  if (data.coinAwards.isAwarded) {
    this.inCoinAwards = true;
    this.coinAwards = data.coinAwards.coinAwards;
    this.coinAwardsTotalWin = data.coinAwards.winAmount;
    this.addCoinAwardsStartToQueue(
      data.coinAwards.coinAwards,
      data.coinAwards.winAmount,
      data.coinAwards.winCapped
    );
  }

  this.baseGameSpinData = data;
  if (!data.cashLink.isAwarded) {
    this.finishSpin(data);
  }

  return spinEvent.totalWinnings;
};

GatiServer.prototype.addSpinDataToQueue = function (event) {
  var message = {};
  message.type = "spinner:SpinEvent";

  message.panelMultiplier = 1;
  message.lines = event.lines;
  message.isPrePaidGame = this._isPrePaidGame;
  message.baseBet = this._stake;
  message.betMultiplier = 1;
  message.totalWinnings = event.totalWinnings;
  message.resultPanel = {};
  message.resultPanel.reels = 5;
  message.resultPanel.rectangular = true;
  if (event.jackpotGame !== undefined && event.jackpotGame === true) {
    message.jackpotGame = true;
  }

  message.resultPanel.reelList = event.resultsPanel.reelList;
  message.resultPanel.symbolsAbove = event.resultsPanel.symbolsAbove;
  message.resultPanel.symbolsBelow = event.resultsPanel.symbolsBelow;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.setUpSpinEventData = function (data) {
  //NOTE: HB: The spin event data is not in usual format

  let spinEventData = {};

  spinEventData.resultsPanel = {};
  spinEventData.lines = data.payLines.winningLines;
  spinEventData.totalWinnings = data.winAmount;
  spinEventData.resultsPanel.reelList = data.stopWindow.reelList;
  spinEventData.resultsPanel.symbolsAbove = data.stopWindow.symbolsAbove;
  spinEventData.resultsPanel.symbolsBelow = data.stopWindow.symbolsBelow;

  return spinEventData;
};

GatiServerGame.prototype.replaceSuperWildOnReel = function (
  symbolsList,
  symbolId
) {
  for (let row = 0; row < symbolsList.length; row++) {
    if (
      gameData.symbols[`Stacked_Wild`].ID === symbolsList[row].value ||
      gameData.symbols[`Symbol_Wild_1x1`].ID === symbolsList[row].value
    ) {
      symbolsList[row].value = symbolId;
    }
  }
};

GatiServerGame.prototype.removeSuperWildOnReel = function (symbolsList) {
  for (let row = 0; row < symbolsList.length; row++) {
    let rand = Math.floor(Math.random() * (4 - 0 + 1)) + 0;
    if (
      gameData.symbols[`Stacked_Wild`].ID === symbolsList[row].value ||
      gameData.symbols[`Symbol_Wild_1x1`].ID === symbolsList[row].value
    ) {
      symbolsList[row].value = rand;
    }
  }
};

GatiServerGame.prototype.finishSpin = function (data) {
  if (
    data.cashLink.isAwarded &&
    data.cashLink.spins &&
    data.cashLink.spins.length > 0
  ) {
    let coins = [...data.cashLink.spins];
    coins.forEach(function (coin) {
      coin.fblFireball = false;
    });

    let newCoins = [];
    data.cashLink.spins.forEach(function (spin) {
      spin.newCoins.forEach(function (coin) {
        coin.fblFireball = true;
        newCoins.push(coin);
      });
    });
    coins.push(...newCoins);

    this.addCoinsLandedToQueue(coins);
  }
  if (data.potPick) {
    this.addPotBonusStartToQueue(
      data.potPick.potWon,
      data.potPick.sequence,
      data.potPick.winAmount
    );
  }
  this.addEndOfBaseGameSpinToQueue(data.winAmount, data.winCapped);
};

GatiServerGame.prototype.addEndOfBaseGameSpinToQueue = function (
  totalWin,
  isCapped
) {
  var message = {};
  message.type = "8bof:EndOfBaseGameSpinEvent";
  message.totalWin = totalWin;
  message.isCapped = isCapped;
  this._messageQueue.push(message);
};

////FREESPINS
GatiServerGame.prototype.addFSStartToQueue = function (
  numFS,
  volcanoBoosts,
  bonusSymbolPositions
) {
  this.fsCount = 0;
  let message = {};
  message.type = "spinner:FreeSpinsStartEvent";
  message.freeSpinsAwarded = numFS;
  message.volcanoBoosts = volcanoBoosts;
  message.bonusSymbolPositions = bonusSymbolPositions;
  this.fsWinnings = 0;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinDataFS = function (cb) {
  const self = this;
  let spin = this.freeSpins[this.fsCount++];
  let spinEvent = this.setUpSpinEventData(spin);
  let winningLinesEvent = spin.payLines;

  winningLinesEvent.coinWinnings = spin.coinAwards.winAmount;
  if (winningLinesEvent.coinWinnings === undefined) {
    winningLinesEvent.coinWinnings = 0;
  }

  if (spin.isWolfRun) {
    const wolfRunReels = this.getWolfRunReels(spinEvent.resultsPanel.reelList);
    this.addModifierEventToQueue(spin, wolfRunReels);
  }

  this.processWilds(
    spinEvent.resultsPanel.reelList,
    spinEvent.resultsPanel.symbolsAbove,
    spinEvent.resultsPanel.symbolsBelow
  );

  this.processAboveBelowOversize(
    spinEvent.resultsPanel.symbolsAbove,
    spinEvent.resultsPanel.symbolsBelow
  );

  this.addSpinDataToQueue(spinEvent);

  const message = this._messageQueue[this._messageQueue.length - 1];
  message.cashLink = spin.cashLink;
  message.isWolfRun = spin.isWolfRun;
  message.powerPacks = [];

  message.moons = [];
  spin.moons.forEach(function (moon) {
    const symbolId = gameData.symbols["Symbol_Moon"].ID;
    message.moons.push({
      reel: moon.coord.reel,
      row: moon.coord.row,
      symbolId,
      slotCell: moon.coord.reel * gameData.numRows + moon.coord.row,
      numberOfSpins: moon.numberOfSpins,
    });
  });

  message.coins = [];
  spin.coins.forEach(function (coin) {
    const prizeData = self.getPrizeDataFromCoin(coin);
    message.coins.push({
      reel: coin.coord.reel,
      row: coin.coord.row,
      slotCell: coin.coord.reel * gameData.numRows + coin.coord.row,
      symbolId: gameData.symbols["Symbol_Coin"].ID,
      amount: prizeData.value,
      type: coin.type,
      potName: prizeData.potName,
      potValue: prizeData.value,
    });
  });

  spin.powerPacks.forEach(function (pack) {
    const symbolId = gameData.symbols["Symbol_Power_Pack"].ID;
    message.powerPacks.push({
      reel: pack.reel,
      row: pack.row,
      symbolId,
      slotCell: pack.reel * gameData.numRows + pack.row,
    });
  });

  winningLinesEvent.multiplierAtEndOfSpin = spin.multiplierAtEndOfSpin;
  message.currentMultiplier = spin.multiplierApplied;
  message.newMultiplier = spin.multiplierAtEndOfSpin;

  if (spin.coinAwards.isAwarded) {
    this.inCoinAwards = true;
    this.coinAwards = spin.coinAwards.coinAwards;
    this.coinAwardsTotalWin = spin.coinAwards.winAmount;
    this.addCoinAwardsStartToQueue(
      spin.coinAwards.coinAwards,
      spin.coinAwards.winAmount,
      spin.coinAwards.winCapped
    );
  }

  if (spin.retrigger.isAwarded) {
    this.addFSRetriggerToQueue(spin.retrigger.extraSpinsAdded);
  }
  if (
    winningLinesEvent.coinsValue > 0 ||
    (winningLinesEvent.totalLineWinnings > 0 &&
      winningLinesEvent.winningLines.length > 0) ||
    winningLinesEvent.coinWinnings > 0
  ) {
    this.processSuperWildWins(winningLinesEvent, spin.stopWindow.reelList);
    this.addWinningsToQueue(winningLinesEvent);
  }

  if (spin.cashLink.isAwarded) {
    this.inCashLink = true;
    this.cashLinkCount = 0;
    this.cashLinkSpins = spin.cashLink.spins;
    this.cashLinkTotalWin = spin.cashLink.winAmount;
    this.addCashLinkStartToQueue(
      spin.cashLink,
      spin.coins,
      spin.powerPacks,
      spin.winCapped
    );
  } else {
    this.finishFSSpin(spin);
  }

  this.processFSMultiplier(spin);

  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.processFSMultiplier = function (spinData) {
  let message = {};
  message.type = "spinner:FSMultiplier";
  message.currentMultiplier = spinData.multiplierApplied;
  message.newMultiplier = spinData.multiplierAtEndOfSpin;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.processSuperWildWins = function (
  winningLinesEvent,
  reelList
) {
  for (let line = 0; line < winningLinesEvent.winningLines.length; ++line) {
    for (
      let id = 0;
      id < winningLinesEvent.winningLines[line].symbol.ids.length;
      ++id
    ) {
      if (
        winningLinesEvent.winningLines[line].symbol.ids[id] === 9 ||
        winningLinesEvent.winningLines[line].symbol.ids[id] === 10
      ) {
        const reel = winningLinesEvent.winningLines[line].positions[id].reel;
        const row = winningLinesEvent.winningLines[line].positions[id].row;

        winningLinesEvent.winningLines[line].symbol.ids[id] =
          reelList[reel].symbols[row].value;
      }
    }
  }
};

GatiServerGame.prototype.finishFSSpin = function (thisFsOutcome) {
  this.fsWinnings += thisFsOutcome.winAmount;

  if (this.fsCount < this.freeSpins.length) {
    this.addFSDataToQueue(thisFsOutcome);
  } else {
    if (!this.inFBL) {
      this.addFSEndToQueue(this.fsWinnings, thisFsOutcome.winCapped);
      this.addGameCompleteToQueue(this.fsWinnings);
      this.inFreeSpins = false;
    }
  }
};

GatiServerGame.prototype.addFSDataToQueue = function (data) {
  let message = {};

  message.type = "spinner:FreeSpinsDataEvent";
  message.num = this.fsCount + 1;
  message.isWolfRun = data.isWolfRun;
  message.fsWinnings = this.fsWinnings;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSRetriggerToQueue = function (freespinsToAdd) {
  let message = {};
  message.type = "spinner:FreeSpinsRetriggerEvent";
  message.extraSpinsAdded = freespinsToAdd;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSEndToQueue = function (winnings, isCapped) {
  let message = {};

  message.type = "spinner:FreeSpinsEndEvent";
  message.fsWinnings = winnings;
  message.isBigWin = false;
  message.isCapped = isCapped;
  this.fsWinnings = 0;
  this.inFreeSpins = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getCoinIdFromCash = function (coin) {
  const firstCashCoinId = gameData.symbols["Symbol_Coin"].ID;
  const possibleValues = [20, 40, 60, 80, 100, 200, 300, 400, 500];

  // base stake is good for both base game and golden bet
  let stakeController = resourceManager.getController("stakeController");
  let stake = stakeController.getBaseStake("default");

  if (this._inBuyABonus) {
    stake = stakeController.getBaseStake(
      this.cashLinkActive ? "CASHLINK_BUY" : "FREESPINS_BUY"
    );
  }

  const stakeIndependentValue = coin.amount / (stake / gameData.numLines);
  //const stakeIndependentValue = coin.amount;
  const index = possibleValues.indexOf(stakeIndependentValue);
  if (index >= 0) {
    return firstCashCoinId + index;
  }
  return -1;
};

GatiServerGame.prototype.getMoonIdFromPot = function (moon) {
  //const symbols = resourceManager.getConfiguration().symbols;
  const firstPotCoinId = gameData.symbols["Symbol_CoinMini"].ID;
  const possibleValues = ["Mini", "Minor", "Major", "Mega"];
  const index = possibleValues.indexOf(fireball.potName);

  if (index >= 0) {
    return firstPotCoinId + index;
  }
  return -1;
};

GatiServerGame.prototype.getCoinIdFromPot = function (coin) {
  const firstPotCoinId = gameData.symbols["Symbol_CoinMini"].ID;
  const possibleValues = ["Mini", "Minor", "Major", "Mega"];
  const index = possibleValues.indexOf(coin.potName);

  if (index >= 0) {
    return firstPotCoinId + index;
  }
  return -1;
};

GatiServerGame.prototype.getCoinId = function (coin) {
  switch (coin.type) {
    case "Cash":
    case "WildCash": {
      return 11;
    }
    case "Pot":
    case "WildPot": {
      return 11;
    }
    case "Multiplier":
    case "WildMultiplier": {
      return 11;
    }
    default: {
      console.log("fireball id error");
    }
  }
  return -1;
};

GatiServerGame.prototype.getPrizeDataFromCoin = function (coin) {
  let prizeData = { type: coin.type };

  switch (coin.type) {
    case "Cash":
    case "WildCash": {
      prizeData.value = coin.amount;
      break;
    }
    case "Pot":
    case "WildPot": {
      prizeData.potName = coin.potName;
      prizeData.value = coin.potValue;
      break;
    }
    case "Multiplier":
    case "WildMultiplier": {
      prizeData.value = coin.multiplier;
      break;
    }
    default: {
      console.log("fireball id error");
    }
  }
  return prizeData;
};

GatiServerGame.prototype.addCashLinkStartToQueue = function (
  cashLinkData,
  startingCoins,
  powerPacks,
  winCapped
) {
  var message = {};

  message.type = "powerPack:cashLinkStartEvent";
  message.startingCoins = [];

  const self = this;
  if (startingCoins) {
    startingCoins.forEach(function (coin) {
      const prizeData = self.getPrizeDataFromCoin(coin);
      message.startingCoins.push({
        reel: coin.coord.reel,
        row: coin.coord.row,
        slotCell: coin.coord.reel * gameData.numRows + coin.coord.row,
        symbolId: gameData.symbols["Symbol_Coin"].ID,
        amount: prizeData.value,
        type: coin.type,
        potName: prizeData.potName,
        potValue: prizeData.potValue,
      });
    });
  }

  //NOTE: Cash link coin converts to normal coin
  let coin = cashLinkData.cashLinkCoin;
  let prizeData = self.getPrizeDataFromCoin(coin);

  message.cashLinkSymbol = {
    reel: coin.coord.reel,
    row: coin.coord.row,
    slotCell: coin.coord.reel * gameData.numRows + coin.coord.row,
    symbolId: gameData.symbols["Symbol_Coin"].ID,
    amount: prizeData.value,
    type: coin.type,
    potName: prizeData.potName,
    potValue: prizeData.value,
  };
  message.powerPacks = [];
  message.totalCashLinkWin = cashLinkData.winAmount;
  powerPacks.forEach(function (pack) {
    const symbolId = gameData.symbols["Symbol_Power_Pack"].ID;
    message.powerPacks.push({
      reel: pack.reel,
      row: pack.row,
      symbolId,
      slotCell: pack.reel * gameData.numRows + pack.row,
    });
  });

  message.livesRemaining = cashLinkData.startingNumberOfLives;
  message.multiplier = cashLinkData.multiplier;
  message.megaPotAwarded = cashLinkData.megaPotAwarded;
  message.winCapped = winCapped;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addCashLinkDataToQueue = function (
  blanks,
  newCoins,
  livesRemaining,
  newPowerPacks
) {
  var message = {};

  message.type = "powerPack:cashLinkDataEvent";

  const self = this;

  message.blanks = blanks;
  message.newCoins = [];
  message.newPowerPacks = [];
  newCoins.forEach(function (coin) {
    const prizeData = self.getPrizeDataFromCoin(coin);
    message.newCoins.push({
      reel: coin.coord.reel,
      row: coin.coord.row,
      slotCell: coin.coord.reel * gameData.numRows + coin.coord.row,
      symbolId: gameData.symbols["Symbol_Coin"].ID,
      amount: prizeData.value,
      type: coin.type,
      potName: prizeData.potName,
      potValue: prizeData.value,
    });
  });

  newPowerPacks.forEach(function (pack) {
    const symbolId = gameData.symbols["Symbol_Power_Pack"].ID;
    message.newPowerPacks.push({
      reel: pack.reel,
      row: pack.row,
      slotCell: pack.reel * gameData.numRows + pack.row,
      symbolId: gameData.symbols["Symbol_Power_Pack"].ID,
    });
  });

  message.livesRemaining = livesRemaining;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addCashLinkEndToQueue = function (win) {
  var message = {};

  message.type = "powerPack:cashLinkEndEvent";
  message.winAmount = win;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addCoinAwardsStartToQueue = function (
  coinAwards,
  winAmount,
  winCapped
) {
  var message = {};

  message.type = "powerPack:coinAwardsStartEvent";
  message.coinAwards = [];
  const self = this;
  if (coinAwards) {
    coinAwards.forEach(function (coin) {
      const prizeData = self.getPrizeDataFromCoin(coin.coin);
      message.coinAwards.push({
        reel: coin.coin.coord.reel,
        row: coin.coin.coord.row,
        slotCell: coin.coin.coord.reel * gameData.numRows + coin.coin.coord.row,
        symbolId: gameData.symbols["Symbol_Coin"].ID,
        amount: coin.winAmount,
        type: coin.coin.type,
        potName: prizeData.potName,
        potValue: prizeData.value,
      });
    });
  }

  message.winAmount = winAmount;
  message.winCapped = winCapped;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addCoinsLandedToQueue = function (fireballs) {
  var message = {};

  message.type = "powerpack:cashLinkLandedEvent";
  message.fireballs = fireballs;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addPotBonusStartToQueue = function (
  potWon,
  sequence,
  winAmount
) {
  var message = {};

  message.type = "8bof:PotBonusStartEvent";
  message.potWon = potWon;
  message.sequence = sequence;
  message.winAmount = winAmount;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.checkForSuperWildOnReel = function (
  symbols,
  start,
  count
) {
  const sWild = 10;
  let allSWilds = true;

  for (let row = start; row < start + count; ++row) {
    if (symbols[row].value != sWild) {
      allSWilds = false;
    }
  }
  return allSWilds;
};

GatiServerGame.prototype.addPotBonusStartToQueue = function (
  potWon,
  sequence,
  winAmount
) {
  var message = {};
  message.type = "8bof:PotBonusStartEvent";
  message.potWon = potWon;
  message.sequence = sequence;
  message.winAmount = winAmount;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.checkForSuperWildOnReel = function (
  symbols,
  start,
  count
) {
  const sWild = 10;
  let allSWilds = true;

  for (let row = start; row < start + count; ++row) {
    if (symbols[row].value != sWild) {
      allSWilds = false;
    }
  }
  return allSWilds;
};

GatiServerGame.prototype.addModifierEventToQueue = function (
  data,
  wolfRunReels
) {
  var message = {};
  message.type = "game:wolfRun";
  message.wolfRunReels = wolfRunReels;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getWolfRunReels = function (reelList) {
  let wolfRunReels = [];

  for (let reel = 0; reel < reelList.length; reel++) {
    wildStackAmount = 0;
    for (let row = 0; row < reelList[reel].symbols.length; row++) {
      //NOTE: If stacked wild
      if (
        reelList[reel].symbols[row].value ===
          gameData.symbols[`Symbol_Wild_1x1`].ID ||
        reelList[reel].symbols[row].value ===
          gameData.symbols[`Stacked_Wild`].ID
      ) {
        reelWithWildStack = reel;
        //NOTE: Find how stacked
        wildStackAmount++;
      }
    }
    if (wildStackAmount === 4) {
      wolfRunReels.push({ wolfRunReel: reel });
    }
  }

  return wolfRunReels;
};

GatiServerGame.prototype.getCashLinkSpinData = function (cb) {
  const thisOutcome = this.cashLinkSpins[this.cashLinkCount];

  if (this.cashLinkCount < this.cashLinkSpins.length) {
    ++this.cashLinkCount;
    this.addCashLinkDataToQueue(
      thisOutcome.blanks,
      thisOutcome.newCoins,
      thisOutcome.livesRemaining,
      thisOutcome.newPowerPacks
    );
  } else {
    this.addCashLinkEndToQueue(this.cashLinkTotalWin);
    this.inCashLink = false;

    if (this.inFreeSpins) {
      let thisFsOutcome = this.freeSpins[this.fsCount - 1];
      this.finishFSSpin(thisFsOutcome);
    } else {
      this.finishSpin(this.baseGameSpinData);
    }

    if (!this.inFreeSpins || this.fsCount >= this.freeSpins.length) {
      this.inFreeSpins = false;
      this.addGameCompleteToQueue(0);
    }
  }
  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.addDemotionsToQueue = function (demotions) {
  var message = {};
  message.type = "8bof:Demotions";
  message.demotions = demotions;

  this._messageQueue.push(message);
};

GatiServer.prototype.getCheatString = function () {
  return this.force;
};

GatiServer.prototype.logCheatString = function () {
  this.force =
    this._latestEngineReponse.wager.bets[0].eventdata.response.clientData.Repro;

  if (this.force !== "") {
    console.log("force: " + this.force);
  }
};

GatiServer.prototype.addCheatToRequest = function (request, forces) {
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  request.cheat = forces;
};

GatiServer.prototype.updateForces = function (forces) {
  if (!forces) return undefined;
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  return forcesJson;
};

GatiServer.prototype.endGame = async function (cb) {
  this._endGame = true;
  await this.doEndGame(cb);
  this._endGame = false;
};
